import { useMemo } from 'react';
import {
    useClinicalListsListSites,
    useClinicalListsListTags,
} from '~/backend/connector-next-api/connector-next-components';
import type { ClinicalLists } from '../model';

/**
 * The installation's clinical tags and treatment sites, each as soon as it
 * has loaded, so one that fails does not hide the other. `isError` while
 * either failed before it loaded; a read that fails after loading keeps what
 * it loaded.
 */
export function useClinicalLists(): {
    data: ClinicalLists;
    isError: boolean;
} {
    const tags = useClinicalListsListTags({});
    const sites = useClinicalListsListSites({});
    const data = useMemo(
        () => ({ tags: tags.data, sites: sites.data }),
        [tags.data, sites.data]
    );
    return {
        data,
        isError:
            (tags.isError && tags.data === undefined) ||
            (sites.isError && sites.data === undefined),
    };
}
